import { Icon, useStyleConfig } from '@chakra-ui/react';
import React from 'react';

import { WLIconProps } from '../icon.props.interface';

const StudentLoanReliefIcon: React.FC<WLIconProps> = ({ variant, ...rest }) => {
  const styles = useStyleConfig('Icon', { variant });

  return (
    <Icon viewBox="0 0 200 200" {...rest} __css={styles}>
      <desc id="svgdescStudenLoan">graduation cap with a dollar symbol</desc>
      <circle className="background" cx="100" cy="100" r="84.3" />
      <path
        d="M135.5 118.7c4.3-2.9 7.3-6.8 7.3-12.6V87.6l-7.3 3ZM160 72.8l-54.8-22.1a4.6 4.6 0 0 0-3.4 0l-54.5 22a1.2 1.2 0 0 0 0 2.3l54.5 22a4.5 4.5 0 0 0 3.5 0l21.9-8.9L105 77.4a11.5 11.5 0 0 1-1.5 0c-3.4 0-6.2-1.6-6.2-3.6s2.8-3.7 6.2-3.7 6.3 1.7 6.3 3.7a2.4 2.4 0 0 1-.4 1.2l22.8 11L160 75a1.2 1.2 0 0 0 0-2.2Z"
        className="accent"
      />
      <path
        d="M83.5 121.3a22.5 22.5 0 0 1-.2 2.8 78.3 78.3 0 0 0 37.4.7v6.5a5.4 5.4 0 0 0 10.4 2.3 4.7 4.7 0 0 1-5-4.6V94.3l-20 8c-1.8.7-3 1-4.8.2l-37-15v10.9a23.3 23.3 0 0 1 19.2 23Z"
        className="accent"
      />
      <path
        d="M41.6 121.3a18.6 18.6 0 1 0 18.6-18.6 18.6 18.6 0 0 0-18.6 18.6Z"
        className="accent"
      />
      <path
        d="m53.3 132.3.2-4.2.3-.1a6.5 6.5 0 0 0 4.5 1.8c2.4 0 3.2-1.5 3.2-2.7s-.6-1.9-2.7-3.2l-1.5-1c-1.7-1.2-4.1-2.9-4.1-6.3a6.5 6.5 0 0 1 5.8-6.8l-.1-3 .2-.3h2.6l.2.3v3a10.8 10.8 0 0 1 4.3 1.2l.2.3c-.2 1.5-.3 2.6-.3 4.2h-.3a5.7 5.7 0 0 0-4-1.7c-1 0-2.7.7-2.7 2.3 0 1 .7 1.9 2.1 2.7l1.7 1c3.2 2 4.7 3.5 4.7 6.7a7.2 7.2 0 0 1-6.4 7.2v3.3l-.1.2h-2.7l-.2-.2v-3a11.4 11.4 0 0 1-4.7-1.3Z"
        className="background"
        style={{
          fill: variant === 'darkIconNoBackground' ? 'white' : undefined,
        }}
      />
    </Icon>
  );
};

export default StudentLoanReliefIcon;
